export const constants = {
  LOGIN_SUCCESS_REDIRECT_URI: "/loginSuccess",
  CHECK_LOGIN_URI: "/checkLogin",
  LOGIN_SUCCESSED_REDIRECT_URI: "/home",
  USER_SIGNOUT_URI: "/UserSignOut",
  GET_USER_PHOTO_URI: "/getUserPhoto",
  GET_USER_ME: "/User/Me",

  //Home
  FIRM_DASHBOARD_URI: "/api/home/index",
  FIRM_USER_COUNT: "/api/home/userCount",
  FIRM_DASHBOARD_MATTER_STATUS: "/api/home/matterStatus",
  FIRM_DASHBOARD_MATTER_USER_STATUS: "/api/home/getMatterUserStatus",
  FIRM_DASHBOARD_USER_DEADLINES: "/api/home/getUserDeadlineStatus",
  DASHBOARD_GET_FIRM_SUBSCRIPTION_DETAILS:
    "/api/home/getFirmSubscriptionDetailInDashboard",
  GET_USER_DEADLINE_FILTER_BY_MONTH: "/api/home/getUserDeadlineFromMonth",
  // Firm
  FIRM_PROFILE_URI: "/api/firm/profile",
  FIRM_UPDATE_PROFILE_URI: "/api/firm/update",
  FIRM_SETTING_URI: "/api/firm/index",
  SAVE_FIRM_SETTING_URI: "/api/firm/saveSetting",
  UPDATE_FIRM_SUBSCRIPTION: "/api/firm/updateFirmSubscription",
  EDIT_FIRM_SUBSCRIPTION: "/api/firm/editFirmSubscriptionInformation",
  RESYNC_FIRM_SUBSCRIPTION: "/api/firm/resyncFirmLicense",
  FIRM_NOTIFICATION_SETTINGS: "/api/firm/notificationsetting",
  FIRM_DEADLINE_AUDIT_SETTNG: "/api/firm/getDeadlineAuditSetting",
  UPDATE_FIRM_AUDIT_SETTING: "/api/firm/updateDeadlineAudSetting",
  AUDIT_NO_SYNC_REPORT: "/api/matter/auditNoSyncUser",
  GET_FIRM_AUDIT_NO_SYNC_REPORT: "/api/firm/getNosyncReport",
  FIRM_SEND_ADMINCONSENT_EMAIL: "/api/firm/sendAdminConsentEmail",
  SEND_PLUGIN_ACTIVATION_EMAIL: "/api/plugin/sendPluginActivatedEmail",
  FIRM_SIGNEDUP_SEND_ADMINCONSENT_EMAIL: "Account/SendAdminConsentEmail",
  GET_ALL_PRACTICE_AREA: "/api/firm/practiceareas",
  GET_FIRM_PRACTICE_AREA: "/api/firm/firmpracticearea",
  INSERT_UPDATE_FIRM_PRACTICE_AREA: "/api/firm/insertUpdateFirmPracticeArea",
  GET_APP_PERMISSION: "/api/firm/getAppPermission",
  CHECK_DESIGNATED_USER: "/api/firm/checkValidDesignatedToken",
  CHECK_AUTO_SYNC_DEADLINE: "/report/checkAutoSyncDeadline",
  TEST_AI_CREDENTIALS: "/api/keyvault/checkcredentials",
  TEST_BETA_AI_CREDENTIALS: "/api/keyvault/checkbetacredentials",
  GET_FIRM_HEALTH_STATUS: "/api/firm/getAppHealthStatus",
  GET_USER_OPTIONS_TO_LOAD: "/api/firm/getUsersToLoad",
  LOAD_USER_AS_DESIGNATED_USER: "/api/firm/setLoadedUser",
  UNLOAD_SYNC_DESIGNATED_USER: "/api/firm/unload",
  GET_FIRM_INFO_BY_ID: "/api/firm/getFirmInfo",
  //Matter
  CHECK_DUPLICATE_MATTER_URI: "/Matter/CheckDuplicate",
  MATTER_SAVE_URI: "/Matter/SaveMatter",

  MATTER_CREATE_URI: "/Matter/Create",
  MATTER_GET_RULESET_URI: "/Matter/Toolsets",
  CREATE_MATTER_GROUP_URI: "/Group/Create",
  ADD_MEMBER_TO_GROUP: "/Group/AddMembersToGroup",
  ACCESS_ALL_MEMBER_MATTER: "/Matter/MatterAccessToAllMember",
  ADD_All_USER_GROUP_EVENT: "/Group/AddAllMemberToFutureEvents",
  MANAGE_MATTER_URI: "/Matter/Index",
  GET_USER_MATTER_URI: "/Matter/List",
  GET_MATTER_SHARED_USER_URI: "/Matter/Access",
  CHECK_MATTER_GROUP_URI: "/Matter/CheckMatterGroup",
  CLOSE_MATTER_URI: "/Matter/CloseNoGroupMatter",
  CLOSE_USER_MATTER_URI: "/Matter/CloseMatter",
  RESYNC_USER_MATTER_URI: "/Group/CheckGroupMember",
  GET_CONFIGURE_TEAMS_URI: "/Team/Index",
  CONFIGURE_TEAMS_EDIT_URI: "/Team/Edit",
  CONFIGURE_TEAMS_UPDATE_URI: "/Team/Update",
  CONFIGURE_TEAMS_CREATE_URI: "/Team/AddChannel",
  CONFIGURE_TEAMS_DELETE_URI: "/Team/Delete",
  GET_NAMING_POLICY_URI: "/Matter/NamingPolicy",
  NAMING_POLICY_EDIT_URI: "/Matter/EditNamingPolicy",
  NAMING_POLICY_UPDATE_URI: "/Matter/UpdateNamingPolicy",
  NAMING_POLICY_CREATE_URI: "/Matter/CreateNamingPolicy",
  NAMING_POLICY_DELETE_URI: "/Matter/DeleteNamingPolicy",
  MATTER_OPEN_MATTER_URI: "/Matter/open",
  GET_FIRM_NAMING_POLICY_URI: "/Matter/FirmNamingPolicy",
  GET_FIRM_USER_MATTER_URI: "/Matter/GetUserFirmMatter",
  GET_MATTER_LIST_FOR_DROPDOWN: "/api/matter/getMatterDropDown",
  MATTER_TEMPLATE_DOWNLOAD: "/Matter/Download",
  MATTER_DASHBOARD: "/api/Matter/Dashboard",
  MATTER_CHECK_DUPLCATE: "/api/Matter/CheckDuplicateCaseName",
  MATTER_UPDATE: "/api/Matter/Update",
  MATTER_GET_RECENT_BY_USERID: "/api/matter/recent",
  CHECKING_FOR_USER_VALID_LICENSE: "/api/matter/CheckingForUserValidLicense",
  GET_MATTER_COURT_HOLIDAYS:"/api/matter/courtHolidays",

  //Group
  GET_GROUP_DETAIL_URI: "/Group/List",
  DOWNLOAD_GROUP_DETAIL_URI: "/Group/Download",
  ADD_MEMBER_TO_GROUP_URI: "/Group/AddToGroup",
  ADD_TO_FUTURE_EVENTS_URI: "/Group/AddToFutureEvents",
  REMOVE_USER_FROM_GROUP_URI: "/Group/RemoveUserFromGroup",
  REMOVE_USER_MATTER_ACCESS_URI: "/Matter/SaveAccess",
  UPDATE_USER_FROM_GROUP_URI: "/Group/UpdateEventAttendee",
  SYNC_GROUP_URI: "/Group/MSGroupDetails",
  ADD_MEMBER_TO_UNSYNC_GROUP: "/Group/AddMemberToUnsyncGroup",
  GROUP_UPDATE_GROUPNAME: "/Group/GetGroupNameAsync",
  GROUP_SYNC: "/api/group/sharepointurl/sync",
  GROUP_RESYNC_USERS_SPBROKEN_APPOINTMENTS: "/Group/ResyncUserSpecificBrokenAppointments",
  REMOVE_USER_FROM_DEADLINE: "/Group/RemoveUser",

  //Deadline
  Get_MATTER_DEADLINE_URI: "/Deadline/Index",
  ADD_DEADLINE_EVENT_URI: "/Deadline/AddEvents",
  DELETE_DEADLINE_EVENT_URI: "/Deadline/DeleteEvents",
  DELETE_DEADLINE_URI: "/Deadline/Delete",
  RESYNC_DEADLINE_URI: "/Deadline/ResyncAppointments",
  HIDE_DEADLINE_URI: "/Deadline/HideDeadline",
  GET_HIDDEN_DEADLINE_URI: "/Deadline/GetHiddenDeadline",
  GET_HIDDEN_DEADLINE_TEMPLATE_URI: "/Deadline/HiddenDeadlineTemplate",
  CALCULATE_DEADLINE_URI: "/Deadline/TriggerDates",
  CREATE_DEADLINE_URI: "/Deadline/Create",
  UPDATE_MATTER_RULESET_URI: "/Deadline/UpdateRuleSet",
  IMPORT_MATTER_URI: "/Matter/Import",
  SAVE_RULESET_NOTE_URI: "/Deadline/AddRuleSetNote",
  UPDATE_RULESET_NOTE_URI: "/Deadline/UpdateRuleSetNote",
  DELETE_RULESET_NOTE_URI: "/Deadline/DeleteRuleSetNote",
  DOWNLOAD_CSV_URI: "/Deadline/Download",
  IMPORT_DEADLINE_URI: "/Deadline/Import",
  DEADLINE_EMAIL: "/deadline/email",
  DEADLINES_GET_UPCOMING: "/api/deadline/upcoming",
  DEADLINES_UPDADTE_LABELS: "/Deadline/UpdateLabel",
  DEADLINE_HISTORY: "/Deadline/History",
  DEADLINE_VIEW_ATTENDEES: "Deadline/GetAttendeeListByEventID",
  DEADLINE_ADD_EVENT: "Deadline/AddEvent",
  DEADLINE_RESYNC_EVENT: "Deadline/ResyncEvent",
  DEADLINE_DELETE_EVENT: "Deadline/DeleteEvent",
  //Hearing Notes
  GET_HEARING_NOTES: "/HearingNote/gethearingNotes",
  HEARING_NOTES_EDIT: "/HearingNote/GetHearingNoteByID",
  HEARING_NOTES_UPDATE: "/HearingNote/UpdateHearingNoteByID",
  GET_FIRM_UNSYNCED_DEADLINES: "/report/unsynceddeadlines",

  //Report
  DOWNLOAD_MATTER_FILE: "/Report/ExportMatterFile",
  DOWNLOAD_ACTIVE_MATTER_FILE: "/Report/ExportActiveMatter",
  DOWNLOAD_ARCHIVE_MATTER_FILE: "/Report/ExportArchiveMatter",
  DOWNLOAD_USER_REPORT: "/Report/ExportUserFile",
  DOWNLOAD_DEADLINE_REPORT: "/Report/ExportReport",
  GET_DATERANGE_REPORT: "/Report/Meetings",
  GET_DATERANGE_REPORT_URI: "/Report/Deadlines",
  GET_CASE_REPORT_USER: "/Report/CaseSharingReport",
  GET_MATTER_ARCHIVE_REPORT: "/Report/MatterArchiveReport",
  GET_CASESHARING_REPORT_URI: "/Report/Sharing",
  DOWNLOAD_MATTER_REPORT_HELPER_LINK: "/Report/DownloadCSV",
  DOWNLIAD_DEADLINE_REPORT_HELPER_LINK: "/Report/DownloadDeadlineCSV",
  GET_RULECHANGE_REPORT: "/Report/RuleChangeReport",
  GET_RULECHANGE_REPORT_URI: "/Report/RuleChange",
  DOWNLOAD_RULECHANGE_REPORT: "/Report/RuleChangeReportCSV",
  GET_MODIFIED_REPORT_USER: "/Report/ModifiedReport",
  GET_MODIFIED_REPORT_URI: "/Report/ModifiedReportDeadlines",
  DOWNLOAD_MODIFIED_REPORT: "/Report/ModifiedDeadlinesReportCSV",
  EMAIL_REPORT_URI: "/Report/Email",
  CASE_SHARING_EMAIL_URI: "/Report/SharingEmail",
  AUDIT_USER_CALENDAR: "/Report/AuditUserCalendar",
  GET_UNSYNC_DEADLINES: "/Report/GetUnsyncedDeadlines",
  ICAL_SYNC_REPORT: "/Report/ical/DocketingUserSyncCalendar",
  DOWNLOAD_MATTER_ARCHIVE_REPORT: "/Report/DownloadMatterArchiveReport",
  EMAIL_MATTER_ARCHIVE: "/Report/SharingEmailForArchiveReport",
  FILTER_DEADLINES_BY_SEARCH_TEXT: "/Report/FilterDeadlinesBySearchText",
  UPDATE_EVENTS: "/api/report/attachevent",
  EVENTS_REPORT_CSV: "/api/report/download-event-csv",
  EVENTS_CANCELLED_EVENT_CSV: "/api/report/download-cancelled-event-csv",
  DELETE_DUPLICATE_EVENTS: "/api/report/deleteduplicateevents",
  DOWNLOAD_DUPLICATE_EVENTS: "/api/report/download-duplicate-event-csv",
  GET_MATTER_REPORT: "/Report/MatterReport",
  DOWNLOAD_MATTER_REPORT: "/Report/ExportMatterReport",
  SEND_MATTER_REPORT_EMAIL: "/Report/MatterReportEmail",
  DOWNLOAD_CASESHARING_REPORT: "/Report/SharingCSV",
  GET_CUSTOM_REPORT_TYPE: "/Report/getcustomreporttype",
  LOAD_MILESTONE_REPORT: "/Report/getAllMilestone",
  DOWNLOAD_MILESTONE_REPORT: "/Report/MilestoneReportCSV",
  GET_AI_HISTORY_REPORT_URI: "/Report/getAiHistoryReport",
  GET_AI_ANALYTICAL_REPORT_URI: "/Report/getaiUsageAnalytics",

  //Task
  GET_TASK: "/api/matter/myTask",
  //Clause Bank

  GET_ALL_CLAUSES: "/api/clauseBank/clauses",
  ADD_CLAUSE: "/api/clauseBank/addClause",
  UPDATE_CLAUSE: "/api/clauseBank/updateClauseInfo",
  GET_CLAUSES_BY_FIRM_PRACTICE_AREA_ID: "/api/clauseBank/getClausesByFirmPracticeArea",
  ADD_TEMPLATE: "/api/clauseBank/template",
  UPDATE_IS_PUBLISHED: "/api/clauseBank/updateIsPublished",
  DELETE_CLAUSE: "/api/clauseBank/clause",
  UPDATE_TEMPLATE_STATUS: "/api/clauseBank/updateTemplateStatus",
  UPLOAD_CLAUSE_TEMPLATE: "/api/clauseBank/upload",
  //Contact
  GET_TAGS_URI: "/Tag/Index",
  TAGS_EDIT_URI: "/Tag/Edit",
  TAGS_UPDATE_URI: "/Tag/Update",
  USER_TAGS_UPDATE_URI: "/Tag/UpdateUserTag",
  TAGS_CREATE_URI: "/Tag/Create",
  USER_TAGS_CREATE_URI: "/Tag/CreateUserTag",
  TAGS_DELETE_URI: "/Tag/Delete",
  USER_TAGS_DELETE_URI: "/Tag/DeleteUserTag",
  HAS_TAG_RELATION_WITH_OTHER: "/Tag/HasTagRelationWithOther",
  HAS_TAG_RELATION_WITH_USER: "/Tag/HasTagRelationWithUser",
  LOAD_CONTACT_URI: "/api/contact/load",
  CONTACT_EDIT_URI: "/api/contact/edit",
  CONTACT_UPDATE_URI: "/api/contact/update",
  CONTACT_SAVE_MANUALLY_URI: "/api/contact/saveContactManually",
  CONTACT_DELETE_URI: "/api/contact/delete",
  VIEW_CONTACT_DETAIL_URI: "/api/contact/contactDetail",
  CONTACT_ASSCOCIATED_WITH_MATTER_URI: "/api/contact/getAssociatedContact",
  CONTACT_TAG_EDIT_URI: "/api/contact/editContactTag",
  AI_EDIT_TAG_EDIT_URI: "/api/ai/editAiTag",
  CONTACT_TAG_UPDATE_URI: "/api/contact/updateContactTag",
  AI_TAG_UPDATE_URI: "/api/ai/updateAiTag",
  UPDATE_BULK_USER_TAG: "/api/user/updateSelectedUserTag",
  PREVIEW_TEMP_CONTACT_URI: "/api/contact/loadPreview",
  CONTACT_IMPORT_URI: "/api/contact/import",
  DOWNLOAD_CONTACT_TEMPLATE_URI: "/api/contact/download",
  CONTACT_ADD_PERMANENT_URI: "/api/contact/addContactPermanent",
  CHECK_TAG_EXISTS: "/Tag/Exists",
  CHECK_USER_TAG_EXISTS: "/Tag/checkUserTagExists",
  DELETE_MULTIPLE_CONTACTS: "/api/contact/deleteMultiple",
  DELETE_MULTIPLE_TAGS: "/Tag/DeleteMultiple",
  GET_USER_LIST_BY_TAG_ID: "/Tag/GetUsersByTagId",
  GET_TAG_USERS: "/Tag/tagusers",

  //Ai Tags
  GET_AI_HISTORY: "api/aiHistory",
  SUMMARIZE_BETA_AI: "/api/AiHistory/summarizeBeta",
  COMMON_SPLIT_VIEW_AI: "/api/aiHistory/commonSplitView",
  SUBMIT_FEEDBACK: "/api/aiHistory/submitFeedback",

  //Matter Tags

  GET_MATTER_TAGS: "/Tag/MatterTag",
  GET_AI_TAGS: "/Tag/AiTag",
  USER_EDIT_TAG_URI: "/api/user/editUserTag",
  USER_TAG_UPDATE_URI: "/api/user/updateUserTag",
  USER_TAG_PAGINATION: "/Tag/UserTagPagination",
  AI_TAG_PAGINATION: "/Tag/AiTagPagination",
  MATTER_TAG_PAGINATION: "/Tag/MatterTagPagination",

  //deadline tags
  DEADLINE_TAGS: "/Tag/DeadlineTag",
  CHECK_DEADLINE_TAG_EXISTS: "/Tag/checkDeadlineTagExists",
  DEADLINE_TAGS_CREATE_URI: "/Tag/CreateDeadlineTag",
  DEADLINE_TAGS_UPDATE_URI: "/Tag/UpdateDeadlineTag",
  HAS_TAG_RELATION_WITH_DEADLINE: "/Tag/HasTagRelationWithDeadline",
  DEADLINE_TAGS_DELETE_URI: "/Tag/DeleteDeadlineTag",
  GET_ASSOCIATED_TAG: "Deadline/getAssociatedTag",
  UPDATE_DEADLINE_TAG_URI: "Deadline/updateDeadlineTag",

  //users
  GET_USERS_URI: "/api/user/index",
  USERS_EDIT_URI: "/api/user/edit",
  USERS_UPDATE_URI: "/api/user/update",
  USERS_CHECK_UPN_UPDATE_URI: "/api/user/checkUPN",
  USERS_VIEW_URI: "/api/user/showView",
  USERS_DELETE_URI: "/api/user/delete",
  USERS_ADD_URI: "/api/user/add",
  USERS_SAVE_URI: "/api/user/save",
  USERS_CHECK_EXISTING_URI: "/api/user/checkExistingEmail",
  USERS_GETUSERID_URI: "/api/user/getUserID",
  USERS_SETTINGS_URI: "/api/user/settings",
  USERS_SAVE_SETTING_URI: "/api/user/saveSettings",
  DOWNLOAD_USERS_CSV_URI: "/api/user/download",
  USER_IMPORT_URI: "/api/user/import",
  USER_ADD_PERMANENTLY_URI: "/api/user/addUserPermanent",
  SAVE_ADMIN_SETTING_URI: "/api/user/saveAdminPortalSettings",
  SAVE_PRIVATE_SETTING_URI: "/api/user/saveIsPrivateSettings",
  SAVE_ETICKLE_REMINDER_URI: "/api/user/saveIsETickleReminder",
  SAVE_USER_SCHEDULAR_URI: "/api/user/toggleUserSchedulerStatus",
  CHECK_DOCKETING_USER_URI: "/api/user/checkuser",
  GET_ALL_USERS_IN_OFFICE_365: "/api/user/getUsersInTenant",
  ADD_USERS_FROM_GRAPHS: "/api/user/saveFrom",
  LICENSE_DETAILS: "/api/user/licenseDetails",
  GET_TIMEZONE: "/api/user/getTimezone",
  ADD_USER_MATTER_ACCESS_URI: "/api/user/matterAccess",
  USER_SYNC: "/api/user/sync",
  GET_NOTIFICATION: "/api/user/getNotification",
  GET_SUPPORT: "/api/user/getFAQ",
  DOWNLOAD_POWERSHELL: "/api/user/powerShell",
  DOWNLOAD_POWERSHELL_SECOND: "/api/user/lawtoolBoxInstallPowershell",
  CHECK_DOCKETING_USER_IN_FIRM: "/api/user/docketinguser",
  GET_USER_ASSOCIATED_MATTERS: "/api/user/getUserAssociatedMatters",
  SAVE_EDITOR_RIGHTS: "/api/user/saveEditorRight",
  GRAPH_USER_DETAILS: "/api/user/getUserDetails",


  //Meetings
  GET_MEETING_URI: "/Meeting/Index",
  MEETING_EDIT_URI: "/Meeting/Edit",
  MEETING_UPDATE_URI: "/Meeting/Update",
  MEETING_DELETE_URI: "/Meeting/Delete",
  MEETING_CREATE_URI: "/Meeting/Create",
  MEETING_IMPORT_URL: "/Meeting/Import",
  DOWNLOAD_MEETING_TEMPLATE_URI: "/Meeting/Download",
  MEETINGS_GET_UPCOMING: "/api/meeting/upcoming",

  //Copy Template
  SEARCH_GROUP_ITEMS_URI: "/Group/SearchSourceResult",
  GET_ALL_DRIVE_ITEMS_URI: "/api/file/allDriveItems",
  SEARCH_DESTINATION_FOLDER_URI: "/Group/SearchDestinationResult",
  COPY_DRIVE_ITEM_URI: "/api/file/cloudCopy",
  GET_FOLDER_ITEM_URI: "/api/file/folderItems",

  //tracker
  Get_TRACKER_INDEX: "/api/tracker/index",
  GET_USER_TRACKER_REPORT: "/api/tracker/userTrackers",
  ADD_NEW_TIME_TRACKER: "/api/tracker/addTimeTracker",
  EDIT_TIME_TRACKER: "/api/tracker/edit",
  UPDATE_TIME_TRACKER: "/api/tracker/update",
  DELETE_TRACKER_URI: "/api/tracker/delete",
  DOWNLOAD_TRACKER_REPORT_URI: "/api/tracker/exportCSV",
  POST_TRACKER_URI: "/api/tracker/post",
  GET_USER_TIMER_RATE_URI: "/api/tracker/getUserRate",
  GET_CODE_BY_PARENT_URI: "/api/tracker/retrieveAllSetCodesByParent",
  GET_USER_LAST_TRACKER_URI: "/api/tracker/getUserLastTracker",

  //Plugin

  GET_ALL_PLUGINS: "/api/plugin/index",
  ACTIVATE_PLUGIN: "/api/plugin/activate",
  ACTIVATE_POPUP_PLUGIN: "/api/plugin/activate/frompopup",

  // Notification

  UPDATE_NOTIFICATION: "/api/activity/notify",
  UPDATE_ANNOUNCEMENT_CLICK_COUNT: "/api/user/increaseCount",

  //Activity

  GET_ALL_ACTIVITIES: "/api/activity/index",
  FILTER_ACTIVITIES: "/api/activity/filter",
  DOWNLOAD_ACTIVITY_REPORT: "/api/activity/download",
  ACTIVITY_EMAIL: "/api/activity/email",

  UPDATE_TEAMS: "/api/update/Teams",
  GET_USER_DELETED_ACTIVITIES: "api/Activity/getDeletedActivities",
  DOWNLOAD_USER_DELETED_ACTIVITIES: "api/Activity/download",
  DOWNLOAD_USER_DELETED_ACTIVITY_INDIVIDUAL: "Report/DownloadSharingCSV",

  //AI
  GET_AI_PROVIDERS: "/api/ai/getAiProviders",
  GET_AI_MODELS: "/api/ai/getAiModels",

  //Account
  CHECKING_EXISTING_EMAIL_FOR_SIGNUP: "/Account/CheckExistingEmailForSignUp",

  //NetDocuments

  GET_ALL_CABINATES: "/api/NetDocument/getAllCabinates",
  GET_NET_DOCS_ASSOCIATED_MATTERS:
    "/api/NetDocument/getNetDocsAssociatedMatters",
  SYNC_NET_DOC: "/api/NetDocument/sync",
  DEATTACT_NET_DOCS_MATTER: "/api/NetDocument/deattachNetDocuments",
  CHECK_NETDOCUMENT_TOKEN: "/api/NetDocument/CheckRefreshToken",
  GET_WORKSPACE_URL: "/api/NetDocument/getWorkspaceURL",
  GET_ALL_CLIENTS_IN_CABINET: "/api/NetDocument/GetAllClientsInCabinet",
  SEARCH_MATTERS: "/api/NetDocument/SearchMatter",
  INSERT_OR_UPDATE_ND_PLUGIN_MAP: "/api/NetDocument/InsertOrUpdateNDPluginMap",
  GET_ALL_MATTER_BY_CLIENT_KEY: "/api/NetDocument/GetAllMattersByClientKey",

  GET_NETDOCUMENT_BASEURL_INFO: "/api/NetDocument/getbaseurlInfo",
  UPDATE_NETDOCUMENT_BASEURL: "/api/NetDocument/updateBaseUrl",

  //IManage
  DEATACH_IMANAGE_MATTER: "/api/imanage/deattachFromWorkspace",
  GET_IMANAGE_ASSOCIATED_MATTERS:
    "/api/IManage/getAssociatedMatters",
  GET_IMANAGE_BASEURL_INFO: "/api/Imanage/getbaseurlInfo",
  UPDATE_IMANAGE_BASEURL: "/api/Imanage/updateBaseUrl",


  //Signup Powershell
  SIGNUP_POWERSHELL: "/signupPowershell",

  //KeyVault Setting
  GET_KEY_VAULT_SETTING: "/api/keyVault",
  SAVE_KEY_VAULT_SETTING: "/api/keyVault/save",
  DELETE_KEY_VAULT_SETTING: "/api/keyVault/delete",
  GET_FORM_RECOGNIZOR_SETTING: "/api/keyVault/getFormRecognizor",
  SAVE_FORM_RECOGNIZOR_SETTING: "/api/keyVault/saveFormRecognizor",
  DELETE_FORM_RECOGNIZOR_SETTING: "/api/keyVault/deleteFormRecognizor",
  GET_KEY_AI_MODEL: "/api/keyVault/getAiModel",
  SAVE_KEY_VAULT_AI_MODEL: "/api/keyVault/saveAiModel",
  DELETE_BETA_AI_SETTING: "/api/keyVault/deleteBetaAI",
  GET_MISTRAL_AI_SETTING: "/api/keyVault/getMistralAI",
  SAVE_MISTRAL_AI_SETTING: "/api/keyVault/saveMistralAi",
  DELETE_MISTRAL_AI_SETTING: "/api/keyVault/deleteMistralAi",
  //saas
  GET_SUBSCRIPTION_STATUS: "/api/saas",
  //Notification

  // FIRM_EXT_ADD: "api/FirmExt/Add",
  // FIRM_EXT_GET: "api/FirmExt/GET",
  // FIRM_EXT_UPDATE: "api/FirmExt/Update",

  //DEFAULT_PROFILE:"data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAMAAAANf8AYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABO1BMVEXk5ufl5+jj5ebZ3N3N0NLEyMvBxsjDx8nKztDW2drh4+TY29zAxceyt7qutLets7awtrm7wMPS1dfN0dOzuLvFycvg4+TMz9HCxsnT1tixt7rJzc/f4eO5vsGyuLvO0tTi5OW9wsS0urzc3+Dl5ufc3uCzubyvtbjV2NqwtbjR1dbFyczR1NbU2Nnb3d/Q1Nbh4+W7wMLLz9G/xMbd3+G2vL7U19nP0tSts7fEyMri5ebGysy8wcTe4eLh5OXHy82ttLe+w8bl5+e5v8G1u77Fysy6v8K8wcPP09Te4OHg4uTa3d7DyMrU19ja3N7g4uPd4OHQ1NW4vsC3vb/Y2tzEycu1ur20ubzCx8mxtrnO0dO0ur3Bxcfe4OK1u73IzM7Dx8rf4uO4vcDX2tvP09WvtbfV2Nnc3t////8P1HvNAAAAAWJLR0Roy2z0IgAAAY5JREFUSMftlFdXwjAYhpMqtKykshRRhoJRFBwg4MaBiqDgHuBe//8fCHI4p02wX+680OeiV31Ovr7N9yL0zx8B495D2lAGBm12VXM45S2X20NoG33Iq8gZis9PSReqB4JSzrBODIw4Jb4lNEpMhGFnbJyanYgLCgJHCQdVoRxiccpLE5PWSiI5xSuEea2Hw9MzgkM1wEkR0ZkFIpjr4wQAJ81EJwzMlomIB80DP2hhUcjanwEcvCSMlgXvdm6ZO0jPw0tUMKdQXJFYodU102TrG7CC0OaW3huvRLZzOzIOUlK7rLPalOxpwYSU0g7PGSrH9w/Uw4pk9WB0VM0XtHItEI4en9QRhk7CqHGqnkUY6c7GPOf2QlKxOgwrF5dX7deNuVFyfeOwsKqqR7g5He/W7frBiN01+xnfll/rW1l1GyMWtO7FH1VvEUtovMIHGKsRAJrla9jHIIdv1ETyoQQ7XKM+FmGF0Cej8vxCJRzSNDQqftVlFFOj4jcmxbuxURvpDxnSn6bbKYfMLv0uX8zRVmpckIsmAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA1LTEzVDEwOjM0OjI4KzAwOjAwODqBEwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wNS0xM1QxMDozNDo1MyswMDowMEGlZEwAAAAASUVORK5CYII=",
  // TEMPLATE_CREATE: "/api/team/template/create",
  // TEMPLATE_GETALL: "/api/team/template/all",
  // TEMPLATE_GETBYID: "/api/team/template/",
  // TEMPLATE_DELETE: "/api/team/template/",

  TEMPLATE_TEMPLATE: "/api/TeamTemplate/",
  SET_DEFAULT_FIRM_TEMPLATE: "/api/TeamTemplate/default",
  SEARCH_TEAM_APPS: "/api/team/apps?query=",
  SEARCH_PLUGINS: "/api/plugin/search?query=",
  GETALL_PLUGINS: "/api/plugin/Index?query=",
  DEFAULT_PROFILE:
    "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAMAAAANf8AYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABO1BMVEXk5ufl5+jj5ebZ3N3N0NLEyMvBxsjDx8nKztDW2drh4+TY29zAxceyt7qutLets7awtrm7wMPS1dfN0dOzuLvFycvg4+TMz9HCxsnT1tixt7rJzc/f4eO5vsGyuLvO0tTi5OW9wsS0urzc3+Dl5ufc3uCzubyvtbjV2NqwtbjR1dbFyczR1NbU2Nnb3d/Q1Nbh4+W7wMLLz9G/xMbd3+G2vL7U19nP0tSts7fEyMri5ebGysy8wcTe4eLh5OXHy82ttLe+w8bl5+e5v8G1u77Fysy6v8K8wcPP09Te4OHg4uTa3d7DyMrU19ja3N7g4uPd4OHQ1NW4vsC3vb/Y2tzEycu1ur20ubzCx8mxtrnO0dO0ur3Bxcfe4OK1u73IzM7Dx8rf4uO4vcDX2tvP09WvtbfV2Nnc3t////8P1HvNAAAAAWJLR0Roy2z0IgAAAY5JREFUSMftlFdXwjAYhpMqtKykshRRhoJRFBwg4MaBiqDgHuBe//8fCHI4p02wX+680OeiV31Ovr7N9yL0zx8B495D2lAGBm12VXM45S2X20NoG33Iq8gZis9PSReqB4JSzrBODIw4Jb4lNEpMhGFnbJyanYgLCgJHCQdVoRxiccpLE5PWSiI5xSuEea2Hw9MzgkM1wEkR0ZkFIpjr4wQAJ81EJwzMlomIB80DP2hhUcjanwEcvCSMlgXvdm6ZO0jPw0tUMKdQXJFYodU102TrG7CC0OaW3huvRLZzOzIOUlK7rLPalOxpwYSU0g7PGSrH9w/Uw4pk9WB0VM0XtHItEI4en9QRhk7CqHGqnkUY6c7GPOf2QlKxOgwrF5dX7deNuVFyfeOwsKqqR7g5He/W7frBiN01+xnfll/rW1l1GyMWtO7FH1VvEUtovMIHGKsRAJrla9jHIIdv1ETyoQQ7XKM+FmGF0Cej8vxCJRzSNDQqftVlFFOj4jcmxbuxURvpDxnSn6bbKYfMLv0uX8zRVmpckIsmAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA1LTEzVDEwOjM0OjI4KzAwOjAwODqBEwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wNS0xM1QxMDozNDo1MyswMDowMEGlZEwAAAAASUVORK5CYII=",

  APPOINTMENT_LABELS: [
    "none",
    "done",
    "pending",
    "follow",
    "urgent",
    "ignore",
    "remain",
  ],
  NAMING_POLICY_TYPE: [
    "prefix",
    "suffix",
  ],
  RECURRING_LABELS: [
    { key: "d", value: "Calendar Days" },
    { key: "c", value: "Court Day" },
    { key: "w", value: "Weekly" },
    { key: "m", value: "Monthly" },
    { key: "q", value: "Quarterly" },
    { key: "y", value: "Annually" },
  ],
  NAMING_POLICY_LABELS: [
    { key: "suffix", value: "Suffix" },
    { key: "prefix", value: "Prefix" },
  ],
  MONTHS: [
    {
      value: 1,
      label: "January",
    },
    {
      value: 2,
      label: "February",
    },
    {
      value: 3,
      label: "March",
    },
    {
      value: 4,
      label: "April",
    },
    {
      value: 5,
      label: "May",
    },
    {
      value: 6,
      label: "June",
    },
    {
      value: 7,
      label: "July",
    },
    {
      value: 8,
      label: "August",
    },
    {
      value: 9,
      label: "September",
    },
    {
      value: 10,
      label: "October",
    },
    {
      value: 11,
      label: "November",
    },
    {
      value: 12,
      label: "December",
    },
  ],
  APPOINTMENT_PLUS_VALUE_TYPES: ["Calendar Day", "Court Day", "Month", "Year"],
  FIRMS_ALLOWED_TO_REPORT_SCHEDULER: [],

  SIDEBAR_IDS:
  {
    IManage: 9,
    NetDocument: 8,
    ManageEvents: 14,
    MatterID: 4,
    AISettingID: 15,
    ManageUser: 3,
    ReportID: 5,
    BetaAISettingID: 17
  },

  SETTINGS_NAME: {
    IsPlannerEnabled: "IsPlannerEnabled",
  },
  LICENSE_VALIDATION_MESSAGE: {
    HasNoLicense: "This user has no license and can not be removed. please unshare the cases and  remove this user from LawToolBox admin portal",
    UserNotFound: "User not found in Microsoft 365. Please unshare the cases and  remove this user from LawToolBox admin portal",
  },
  DEFAULT_NETDOCUMENTS_URL: "https://vault.netvoyage.com",
  // TEAM TEMPLATES,
  SEARCH_TEAM_TAB_APPS: "/api/team/tabApps?query=",

  // Shared
  GET_PAGINATED_USER_SEARCH: "api/user/getAllPaginatedUser",

  AI_GENERATAED_DEADLINE: "#aigenerateddeadline",
  DEV_INFO_TRACK_INTERNAL_CODE: "itdev",
  INFO_TRACK_INTERNAL_CODE: "it",

  MATTER_REPORT_DATE_FILTER_TYPE: [
    {
      value: 'cd',
      label: 'Created Date'
    },
    {
      value: 'lu',
      label: 'Last Update'
    }
  ],
  activityOption: [
    {
      value: "(A101) Plan and prepare for",
      label: "Plan and prepare for",
    },
    {
      value: "(A102) Research",
      label: "Research",
    },
    {
      value: "(A103) Draft/revise",
      label: "Draft/revise",
    },
    {
      value: "(A104) Review/analyze",
      label: "Review/analyze",
    },
    {
      value: "(A105) Communicate(in firm)",
      label: "Communicate(in firm)",
    },
    {
      value: "(A106) Communicate (with client)",
      label: "Communicate (with client)",
    },
    {
      value: "(A107) Communicate (other outside counsel)",
      label: "Communicate (other outside counsel)",
    },
    {
      value: "(A108) Communicate (other external)",
      label: "Communicate (other external)",
    },
    {
      value: "(A109) Appear for attend",
      label: "Appear for attend",
    },
    {
      value: "(A110) Manage data files",
      label: "Manage data files",
    },
    {
      value: "(A111) Other",
      label: "Other",
    },
  ],

  netDocsRegion: [
    {
      value: "us",
      label: "US",
      link: "https://vault.netvoyage.com/"
    },
    {
      value: "eu",
      label: "UK",
      link: "https://eu.netdocuments.com/"
    },
    {
      value: "de",
      label: "Germany",
      link: "https://de.netdocuments.com/"
    },
    {
      value: "au",
      label: "Australia",
      link: "https://au.netdocuments.com/"
    },
    {
      value: "can",
      label: "Canada",
      link: "https://can.netdocuments.com/"
    },
  ],

  IMANAGE_ICON_STRING: "data:image/png;base64,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",
};
